import '../style/tips.scss'

const TIPS = '是否要导出当前页数据？(数据导出将被后台监控)'

const TYPE_MAP = {
  1: '由于数据量较大,系统将自动为您发起OA审批,请后续在OA申请中获取数据文件。',
  2: '导出包含加密字段，若选择明文导出，将触发负责人、权限部共同审批。',
  3: '导出数据量大且包含加密字段，若选择明文导出，将触发负责人、权限部共同审批。若选择无需解密，仅触发负责人审批。',
  4: '导出包含加密字段，若选择明文导出，将触发权限部审批。'
}

export default {
  props: {
    type: String,
  },
  data () {
    return {
    }
  },
  render (h) {
    const { type } = this.$props

    const renderIcon = () => {
      return <div class="el-icon-warning"></div>
    }

    const renderTips = () => {
      return <div class="safety-tips">{ TIPS }</div>
    }

    const renderLittleTips = () => {
      return <div class="little-safety-tips">{ TYPE_MAP[type] }</div>
    }

    return (
      <div class="kye-data-export-tips">
        <div class="safety-tips-content">
          { renderIcon() }
          { renderTips() }
        </div>
        { +type !== -1 && renderLittleTips() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-export/components/tips.js